import React, { Component } from "react";
import { Table, Button, Modal, Row, Col, Tooltip, message, Icon } from "antd";
import axios from "axios";
import "./Pages.css";
import FiltrosForm from '../components/FiltrosForm';
import moment from "moment-timezone";
import { getUsuario, getTemPermissao, getTipoUsuario } from "../utils/LoginManager";

const { Column } = Table;
const ButtonGroup = Button.Group;


export default class extends Component {
  state = {
    listaRegistros: [],
    registro: '',
    eventStatus: '',
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,

    formFiltroVisivel: false,

    filtros: {
      tipoTela: 'LOG',
      buscaOrdem: { campo: 'ven_dt_venda', ordem: 'DESC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaMes: 0,
      buscaAno: 0,
      buscaPessoa: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaMunicipio: { key: '0', },
      buscaAgruparCidades: 0,
      buscaGrupoProduto: { key: '0' },
      buscaProduto: { key: '0' },
      buscaTipo: { key: 'X' },
      buscaControle: '',
      buscaAtividade: { key: '0', },
      buscaTipoAtiv: { key: 'X' },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    getTipoUsuario().then(tipoUsuario => {
      this.state.filtros.buscaUsuario = {
        key: getTemPermissao('UsuarioSupervisor', 'cons') ? '0' : usuario.usu_cpf
      }
      this.setState({
        usuario,
        tipoUsuario,
      }, this.getListaRegistros);
    })
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ carregando: true });
    const { pagina, limite } = this.state;

    const { buscaDataIni, buscaDataFim, buscaControle, buscaUsuario, buscaOrdem } = this.state.filtros;

    let dt_ini = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      dt_ini = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let dt_fim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      dt_fim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/usuarios/listaLog', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          numero: buscaControle,
          usuario: buscaUsuario.key,
          dt_ini,
          dt_fim,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;

        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };



  onBuscar = event => {
    event.preventDefault();
    this.getListaRegistros();
  }










  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span style={{ fontSize: 11 }}>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  renderCliente = (usu_nome) => {
    return (
      <span style={{ fontSize: 11 }}>{usu_nome}</span>
    );
  };

  renderTipo = (tipo, registro) => {
    return (
      <div>
        <Tooltip title={tipo === 'I' ? "INCLUSÃO" : tipo === 'A' ? "ALTERAÇÃO" : tipo === 'E' ? "EXCLUSÃO" : "CONSULTA"}>
          <span>{tipo}</span>
        </Tooltip>
      </div>
    );
  };

  renderUsuario = (usu_nome) => {
    return (
      <span style={{ fontSize: 11 }}>{usu_nome.substring(0, 10)}</span>
    );
  };



  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaMes: this.state.filtros.buscaMes,
        buscaAno: this.state.filtros.buscaAno,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaMunicipio: this.state.filtros.buscaMunicipio,
        buscaAgruparCidades: this.state.filtros.buscaAgruparCidades,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaTipo: this.state.filtros.buscaTipo,
        buscaControle: this.state.filtros.buscaControle,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };







  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, filtros, total, pagina, limite, formFiltroVisivel } = this.state;

    // console.log('EntregasPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Log do Sistema</h2>
        <hr />
        <br />

        <div className="pageFiltro" style={{ height: 70 }}>
          <Row>
            <Col xs={8} style={{ marginTop: -5 }}>
              <Button
                onClick={this.onAbrirFiltroClick}
                className="pageFiltro-filtrar"
                style={{ marginRight: 15 }}
              >
                Filtrar
              </Button>

              <FiltrosForm
                visivel={formFiltroVisivel}
                onFiltrarClick={this.onFiltrarClick}
                onCancelarFiltroClick={this.onCancelarFiltroClick}
                filtros={filtros}
              />

            </Col>

          </Row>

        </div>



        <div style={{ marginTop: -30 }}>
          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40', '50'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            // scroll={{ x: 600 }}
            rowKey={(registro => registro.ven_idf)}
          >
            <Column
              key="log_data"
              dataIndex="log_data"
              title={this.renderTitulo("Data")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={"13%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="log_usuario"
              dataIndex="log_usuario"
              title={this.renderTitulo("Usuário")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"8%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="usu_nome"
              dataIndex="usu_nome"
              title={this.renderTitulo("Nome")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderUsuario}
              width={"8%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="log_tipo"
              dataIndex="log_tipo"
              title={this.renderTitulo("Tipo")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderTipo}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="log_tabela"
              dataIndex="log_tabela"
              title={this.renderTitulo("Tabela")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderMunicipio}
              width={"10%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="log_controle"
              dataIndex="log_controle"
              title={this.renderTitulo("Controle")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"15%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="log_chave"
              dataIndex="log_chave"
              title={this.renderTitulo("Chave")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"15%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="log_descricao"
              dataIndex="log_descricao"
              title={this.renderTitulo("Descrição")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"40%"}
              align="left"
              className="listaCadastro"
            />
          </Table>
        </div>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/LogPage.js